import { combineReducers } from "redux";

import analyticsData from "./analytics";
import auth from "./auth";
import chartData from "./charts";
import layout from "./layout";
import poll from "./polling";
import sidePanelData from "./sidepanel";
import smartInsights from "./smartInsights";
import systems from "./systemsAndLiveAlarms";
import tags from "./tagsList";
import user from "./userProfile";
import usersData from "./users";

export default history =>
  combineReducers({
    user,
    systems,
    tags,
    auth,
    poll,
    layout,
    smartInsights,
    usersData,
    sidePanelData,
    chartData,
    analyticsData
  });
